import { API_URL } from './api';

export const BOOTH_DEVICE_KEY = 'sp_booth_device';

const DEVICE_PATTERN = /^[0-9a-f]{32}$/;
let volatileDeviceId = '';
let storageUnavailable = false;

const newDeviceId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const deviceId = (storage) => {
  let current = '';
  try {
    current = storage.getItem(BOOTH_DEVICE_KEY) || '';
  } catch (_error) {
    storageUnavailable = true;
  }
  if (DEVICE_PATTERN.test(current)) return current;
  if (storageUnavailable && DEVICE_PATTERN.test(volatileDeviceId)) return volatileDeviceId;
  const next = newDeviceId();
  volatileDeviceId = next;
  try {
    storage.setItem(BOOTH_DEVICE_KEY, next);
    storageUnavailable = false;
  } catch (_error) {
    storageUnavailable = true;
  }
  return next;
};

export class BoothClientError extends Error {
  constructor(status, detail = '') {
    super(explainError(status, detail));
    this.status = status;
    this.detail = detail;
  }
}

export const explainError = (status, detail = '') => {
  if (status === 503 && detail === 'resting') {
    return "Pizzul's AI is resting right now. Rhyme Brain still works.";
  }
  if (status === 503 && detail === 'out_of_ink') {
    return "Pizzul's out of ink this month. Rhyme Brain still works.";
  }
  if (status === 429 && detail === 'daily_limit') {
    return "That's all of today's Pizzul moves. Back tomorrow. Rhyme Brain still works.";
  }
  if (status === 429 && detail === 'busy') {
    return 'The Booth is packed right now. Give it a minute.';
  }
  if (status === 401 && detail === 'pass') return '';
  if (status === 502) return 'Pizzul blanked. Try again.';
  return 'Something went wrong. Try again.';
};

export const boothFetch = async (path, { method = 'GET', body, pass } = {}) => {
  const cleanPath = String(path || '').replace(/^\/+/, '');
  const response = await fetch(`${API_URL}/api/booth/${cleanPath}`, {
    method,
    credentials: 'omit',
    headers: {
      ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
      'X-Booth-Device': deviceId(window.localStorage),
      ...(pass ? { 'X-Booth-Pass': pass } : {}),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new BoothClientError(response.status, data.detail || '');
  return data;
};

export const shouldRetryPass = (status, detail, alreadyRetried = false) => (
  !alreadyRetried && status === 401 && detail === 'pass'
);
